<template>
  <div>
    <!-- BEGIN Warning alert -->
    <div
      v-if="type === 'warning'"
      :id="id"
      class="alert alert-warning"
      :class="{ 'padding-5': padding }"
      role="alert"
    >
      <button
        v-show="closeable"
        type="button"
        class="close"
        data-dismiss="alert"
        aria-hidden="true"
      >
        &times;
      </button>
      <i v-show="showIcon" class="fa fa-warning"></i> <slot></slot>
    </div>
    <!-- END Warning alert -->

    <!-- BEGIN Danger alert -->
    <div
      v-if="type === 'danger'"
      :id="id"
      class="alert alert-danger"
      :class="{ 'padding-5': padding }"
      role="alert"
    >
      <button
        v-show="closeable"
        type="button"
        class="close"
        data-dismiss="alert"
        aria-hidden="true"
      >
        &times;
      </button>
      <i v-show="showIcon" class="fa fa-times-circle"></i> <slot></slot>
    </div>
    <!-- END Danger alert -->

    <!-- BEGIN Info alert -->
    <div
      v-if="type === 'info'"
      :id="id"
      class="alert alert-info"
      :class="{ 'padding-5': padding }"
      role="alert"
    >
      <button
        v-show="closeable"
        type="button"
        class="close"
        data-dismiss="alert"
        aria-hidden="true"
      >
        &times;
      </button>
      <i v-show="showIcon" class="fa fa-info-circle"></i> <slot></slot>
    </div>
    <!-- END Info alert -->

    <!-- BEGIN Success alert -->
    <div
      v-if="type === 'success'"
      :id="id"
      class="alert alert-success"
      :class="{ 'padding-5': padding }"
      role="alert"
    >
      <button
        v-show="closeable"
        type="button"
        class="close"
        data-dismiss="alert"
        aria-hidden="true"
      >
        &times;
      </button>
      <i v-show="showIcon" class="fa fa-check-circle-o"></i> <slot></slot>
    </div>
    <!-- END Success alert -->
  </div>
</template>

<script>
export default {
  name: "AlertBox",
  props: {
    type: {
      type: String,
      required: true
    },
    id: {
      type: String,
      default: ""
    },
    closeable: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    padding: {
      type: Boolean,
      default: false
    }
  }
};
</script>
